<template>
  <div
    class="receive-order-item tb"
    v-if="funcView.receive_bill_list"
  >
    <custom-tab
      :value="type"
      :list="tabList"
      @input="onTabChange"
      class="tab"
    ></custom-tab>
    <div class="search-hd">
      <el-form
        :inline="true"
        @submit.native.prevent
      >
        <!-- 配置项 -->
        <el-form-item
          style="float: right"
          class="mr-0"
        >
          <custom-column
            :code="tableCode"
            v-model="tableColumn"
          ></custom-column>
        </el-form-item>
        <!-- 搜索栏 -->
        <el-form-item style="float: right">
          <search-input
            v-model="formSearch.keyword"
            :placeholder="$t('fms_receive_bill_item.ding_dan_bian_hao')"
            @fetch="onPageChange({ page: 1 })"
          ></search-input>
        </el-form-item>
        <!-- 更多搜索 -->
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container
      ref="container"
      @search="onPageChange({ page: 1 })"
      @clear="clearFilter()"
    >
      <el-form
        :inline="true"
        label-position="top"
      >
        <el-form-item :label="$t('fms_receive_bill_item.fu_kuan_gong_si')">
          <el-input
            v-model="formSearch.payableOrgName"
            :placeholder="$t('fms_receive_bill_item.fu_kuan_gong_si')"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('fms_receive_bill_item.qrfkrq')">
          <custom-date-picker
            style="width: 100%"
            v-model="formSearch.paymentConfirmTime"
            type="daterange"
            align="right"
            value-format="YYYY-MM-DD HH:mm:ss"
            :init-value="initBillPaymentTime"
            :key="paymentConfirmTimeKey"
          ></custom-date-picker>
        </el-form-item>
        <el-form-item
          :label="$t('fms_receive_bill_item.qrskrq')"
          v-if="type !== 1"
        >
          <custom-date-picker
            style="width: 100%"
            v-model="formSearch.receiveConfirmTime"
            type="daterange"
            align="right"
            value-format="YYYY-MM-DD HH:mm:ss"
          ></custom-date-picker>
        </el-form-item>
        <el-form-item
          :label="$t('fms_receive_bill_item.dao_zhang_ri_qi')"
          v-if="type !== 1"
        >

          <custom-date-picker
            style="width: 100%"
            v-model="formSearch.tradeConfirmTime"
            type="daterange"
            align="right"
            value-format="YYYY-MM-DD HH:mm:ss"
          ></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('fms_receive_bill_item.chuang_jian_shi_jian')">
          <custom-date-picker
            style="width: 100%"
            v-model="formSearch.gmtCreate"
            type="daterange"
            align="right"
            value-format="YYYY-MM-DD HH:mm:ss"
          ></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('fms_receive_bill_item.he_tong_hao')">
          <el-input
            v-model="formSearch.contractNo"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('fms_receive_bill_item.ji_shen_hao')">
          <el-input
            v-model="formSearch.bodyNum"
            clearable
          ></el-input>
        </el-form-item>
        <div class="half-content">
          <el-form-item
            :label="$t('fms_receive_bill_item.she_bei_hao')"
            class="half-width"
          >
            <el-input
              v-model="formSearch.deviceNo"
              :placeholder="$t('fms_receive_bill_item.she_bei_hao')"
              type="number"
              :maxlength="1"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('fms_receive_bill_item.qi_hao')"
            class="half-width"
          >
            <el-input
              v-model="formSearch.termNum"
              :placeholder="$t('fms_receive_bill_item.zhi_chi_qu_jian_ru25')"
              clearable
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table
        ref="table"
        type="checkbox"
        height="100%"
        v-model="tableSelect"
        :data="tableList"
        :column="tableColumn"
        @sort="sortChange"
        @filter="filterChange"
        :clickSelection="true"
        :slots="['termNum','sharingClasses', 'publicCash', 'rest', 'action']"
      >
        <template v-slot:publicCash="scope">
          {{getPublicCash(scope.row)}}
        </template>
        <template v-slot:rest="scope">
          {{getRest(scope.row)}}
        </template>
        <template v-slot:termNum="scope">
          <div>{{ scope.row.termNum }}/{{ scope.row.totalTerm }}</div>
        </template>
        <template v-slot:sharingClasses="scope">
          <div>{{  scope.row.sharingClasses?Array.from(new Set(scope.row.sharingClasses.split(','))).join(","):'-' }}</div>
        </template>
        <template v-slot:action="scope">
          <span></span>
          <!-- 正在交易状态显示 -->
          <el-button
            v-if="funcView.receive_bill_register_collection && [1].includes(scope.row.tradeState)"
            type="text"
            size="mini"
            @click.stop="registerCol(scope.row, funcView.receive_bill_register_collection)"
          >
            {{funcView.receive_bill_register_collection}}
          </el-button>
          <!-- 正在交易状态显示 -->
          <el-button
            v-if="funcView.receive_bill_cancel_register && [1].includes(scope.row.tradeState)"
            type="text"
            size="mini"
            @click.stop="onCancelOrder(scope.row)"
          >
            {{funcView.receive_bill_cancel_register}}
          </el-button>
          <el-button
            v-if="funcView.receive_bill_confirm_collection && [6].includes(scope.row.tradeState)"
            type="text"
            size="mini"
            @click.stop="confirmCollection(scope.row, funcView.receive_bill_confirm_collection)"
          >
            {{funcView.receive_bill_confirm_collection}}
          </el-button>
          <!-- 待确认收款状态显示 -->
          <el-button
            v-if="funcView.receive_bill_reject_collection && [6].includes(scope.row.tradeState)"
            type="text"
            size="mini"
            @click.stop="onReject(scope.row)"
          >
            {{funcView.receive_bill_reject_collection}}
          </el-button>
          <!-- 未核销+未撤消收款 + 交易完成 -->
          <!-- paymentType 订单支付类型，1-付款，2-退款，3-撤消，4-提现 -->
          <el-button
            v-if="funcView.receive_bill_cancel_collection && !scope.row.isAssignTrade && !scope.row.isRevoked && [10].includes(scope.row.tradeState) && scope.row.paymentType !== 3"
            type="text"
            size="mini"
            @click.stop="onRevokeDialog(scope.row)"
          >
            {{funcView.receive_bill_cancel_collection}}
          </el-button>
          <!-- 交易完成，交易拒绝，交易关闭状态显示 -->
          <el-button
            v-if="funcView.receive_bill_check_collection && [10,90,100].includes(scope.row.tradeState)"
            type="text"
            size="mini"
            @click.stop="onCheckCollectionRecords(scope.row)"
          >
            {{funcView.receive_bill_check_collection}}
          </el-button>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      ></custom-page>
    </div>
    <!-- 延期收款/撤销收款 -->
    <approval-dialog
      v-if="dialogVisible"
      :model="dialogModel"
      @close="dialogVisible = false"
      @success="getTableList"
      dialogWidth="1500px"
    ></approval-dialog>
    <!-- 登记收款 -->
    <accounts-registration-dialog
      :model="registerCollectionModel"
      v-if="registerCollectionVisible"
      :cancelRegister="cancelRegister"
      @close="registerCollectionVisible = false"
      @success="getTableList"
      @toConfirm="onToConfirm"
    ></accounts-registration-dialog>
    <!-- 确认收款 -->
    <accounts-confirm-dialog
      :model="confirmCollectionModel"
      v-if="confirmCollectionVisible"
      @close="confirmCollectionVisible = false"
      @success="getTableList"
    ></accounts-confirm-dialog>
    <!-- 查看收款信息 -->
    <accounts-collection-detail-dialog
      :model="dialogModel7"
      v-if="dialogVisible7"
      @close="dialogVisible7 = false"
    ></accounts-collection-detail-dialog>
  </div>
</template>

<script>
/** 应收订单 */
import apis from '@/utils/apis';
import approvalDialog from '@/components/approvalCenter/approval_dialog.vue';
import accountsConfirmDialog from '@/pages/fms/components/accounts_confirm_dialog';
import accountsCollectionDetailDialog from '@/pages/fms/components/accounts_collection_detail_dialog';
import accountsRegistrationDialog from '@/pages/fms/components/accounts_registration_dialog';
import commonMixin from '@/pages/fms/mixins/commonMixin';
import mixin from '../../components/mixins';

// - 用于调试
const isMock = false;

export default {
  mixins: [commonMixin, mixin],
  components: { accountsRegistrationDialog, accountsConfirmDialog, approvalDialog, accountsCollectionDetailDialog },
  props: {
    type: Number
  },
  data() {
    const initBillPaymentTime = [`${this.$moment().format('YYYY-MM-01')} 00:00:00`, `${this.$moment().format('YYYY-MM-DD')} 23:59:59`];


    return {
      provide: true,
      translate: {},
      dateType: 0,
      tableSelect: [],
      initBillPaymentTime: initBillPaymentTime,
      paymentConfirmTimeKey: 1,
      formSearch: {
        keyword: '',
        bodyNum: '',
        termNum: '',
        orderBy: '',
        orderType: '',
        pageSize: 50,
        pageNum: 1,
        locationName: '',
        payableOrgName: '',
        paymentConfirmTime: [
          this.$momentWorld(initBillPaymentTime[0]),
          this.$momentWorld(initBillPaymentTime[1])
        ],
        receiveConfirmTime: '',
        tradeConfirmTime: '',
        gmtCreate: '',
        deviceNo: '',
        productCode: '',
        invoiceState: '',
        contractNo: '',
      },

      tableList: [],
      totalRows: 0,

      dialogVisible: false,
      dialogModel: {},
      dialogVisible1: false,
      dialogModel1: {},
      dialogVisible2: false,
      dialogModel2: {},
      // 应收管理-确认收款
      dialogVisible3: false,
      dialogModel3: {},
      // 应收管理-登记收款
      dialogVisible4: false,
      dialogModel4: {},
      // 应收管理-收款记录
      dialogVisible5: false,
      dialogModel5: {},
      // 查看收款详情
      dialogVisible7: false,
      dialogModel7: {},
      link: null,

      cancelRegister: true,
    };
  },
  computed: {
    tableCode() {
      const map = {
        3: 'fms_receive_bill',
        1: 'fms_receive_bill_wait',
        2: 'fms_receive_bill_received'
      };
      return map[this.type];
    },
    tabList() {
      return [
        {
          name: this.$t('fms_receive_bill_item.dai_shou_kuan'),
          value: 1
        },
        {
          name: this.$t('fms_receive_bill_item.yi_shou_kuan'),
          value: 2
        },
        {
          name: this.$t('Common.com_all'),
          value: 3
        },
      ];
    }
  },
  mounted: function () {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getTableColumn();

    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });
    this.getDicMap('invoice_state_t', () => {
      this.getTableList();
    });
  },
  methods: {
    // 登记收款
    registerCol(row) {
      const item = Array.isArray(row) ? row[0] : row;
      const reqDetailUrl = this.getPaymentInfoReqUrl(item);
      if (!reqDetailUrl) {
        this.$message.error(
          this.$t('fms_receive_bill_item.sjycqsgjzd')
        );
        return;
      }
      this.cancelRegister = !!this.funcView.receive_bill_cancel_register;
      this.registerCollection(row, this.$t('fms_receive_bill_item.deng_ji_shou_kuan'));
    },
    // 拒绝
    onReject(row) {
      this.$showConfirm(this.$t('fms_receive_bill_item.nqdyjcddzhfkfzcxfkm')).then(() => {
        const billPaymentCode = row.paymentCode;
        if (!billPaymentCode) {
          this.$message.error(
            this.$t('fms_receive_bill_item.sjycqsgjzd')
          );
          return;
        }
        this.$postJSON(`${apis.paymentRevoke}/${billPaymentCode}`, {}, true).then(() => {
          this.$message({
            type: 'success',
            message: this.$t('Common.com_handle_success'),
          });
          this.getTableList();
        });
      });

    },
    // 取消登记
    onCancelOrder(row) {
      this.$showConfirm(this.$t('fms_receive_bill_item.nqdyqxcddzdhbzhwjyzt')).then(() => {
        const billPaymentCode = row.paymentCode;
        if (!billPaymentCode) {
          this.$message.error(
            this.$t('fms_receive_bill_item.sjycqsgjzd')
          );
          return;
        }
        const url = `${apis.paymentCancelPayment}/${billPaymentCode}`;
        this.$postJSON(url, {}, true).then(() => {
          this.$message({
            type: 'success',
            message: this.$t('Common.com_handle_success'),
          });
          this.getTableList();
        });
      });
    },
    // 计算：公账现金
    getPublicCash(row) {
      const { totalTradeAmount = 0, tradeBalanceAmount = 0 } = row;
      return totalTradeAmount - tradeBalanceAmount;
    },
    // 计算：余额
    getRest(row) {
      const { totalTradeAmount = 0, tradeBalanceAmount = 0, totalPaymentAmount = 0 } = row;
      const publicCash = totalTradeAmount - tradeBalanceAmount;
      return Math.max(totalPaymentAmount - publicCash, 0);
    },
    // 查看收款记录
    onCheckCollectionRecords(row) {
      const reqDetailUrl = this.getPaymentInfoReqUrl(row);
      if (!reqDetailUrl) {
        this.$message.error(
          this.$t('fms_receive_bill_item.sjycqsgjzd')
        );
        return;
      }
      this.dialogModel7 = {
        data: {
          billData: [row],
        },
      };
      this.dialogVisible7 = true;
    },
    onTabChange(value) {
      this.$emit('tab', value);
    },
    // 确认收款
    onToConfirm({ billData, resData }) {
      this.confirmCollection(billData, this.$t('fms_receive_bill_item.que_ren_shou_kuan'), resData);
    },
    // 撤销收款弹窗   调用条件： row.changeId || row.billId || row.paymentId
    onRevokeDialog: function (row) {
      if (row.changeId || row.billId || row.paymentId) {
        this.dialogModel.type = 'add';
        this.dialogModel.changeType = 'withdrawal_payment';
        this.dialogModel.changeId = row.changeId;
        this.dialogModel.row = row;
        this.dialogVisible = true;
      } else {
        this.$message.error(
          this.$t('fms_receive_bill_item.sjycqsgjzd')
        );
      }

    },
    // 表格列中，如本期应收金额需要计算，故再此格式化
    formatList(list) {
      const arr = list || [];
      /** 本期应收租金 paymentAmount
本期应收违约金 breakAmount
本期应收逾期费 overdueAmount */
      arr.forEach((item) => {
        const { paymentAmount = 0, breakAmount = 0, overdueAmount = 0 } = item;
        const depositFee = item.termNum === 1 && item.receivableOrgType !== 'SC' ? item.depositFee || 0 : 0;

        const termShouldReceive = paymentAmount + breakAmount + overdueAmount + depositFee;
        item.termShouldReceive = termShouldReceive;

        if (isMock) {
          item.orderId = '';
          item.paymentCode = '';
          item.billPaymentCode = '';
          item.billPaymentId = '';
          item.paymentId = '';
          item.billId = '';
          item.changeId = '';
        }
      });
      return list;
    },

    // 获取表格数据
    getTableList: function () {
      const deviceNo = this.formSearch.deviceNo;
      const deviceNoStr = `${deviceNo}`;
      const termNum = this.formSearch.termNum;
      // 是否为纯数字的字符串
      const testPureNum = /^\d+$/;
      // 是否为 1-3 格式的字符串
      const testRangeNum = /^\d+\-\d+$/;
      if (deviceNoStr.length > 3) {
        this.$message.error(this.$t('fms_receive_bill_item.sbhcdbndy3'));
        return;
      }
      if (termNum) {

        const isPureNum = testPureNum.test(termNum);
        const isRangeNum = testRangeNum.test(termNum);
        if (!isPureNum && !isRangeNum) {
          this.$message.error(this.$t('fms_receive_bill_item.qsrhfqh'));
          return;
        }
      }
      const url = apis.paymentReceivablePaymentPage;
      const reqData = this.getReqListData();
      this.$getJSON(url, reqData).then((res) => {
        this.tableList = this.formatList(res.data.records);
        this.totalRows = res.data.total;
      });
    },
    getReqListData() {
      // 待收款（1-正在交易 - ing，6-待确认收款 - wait_confirmed）
      // 已收款（10-交易完成 - finish，90-交易拒绝 - refuse，100-交易关闭 - close）
      const stateWait = [1, 6];
      const stateReceived = [10, 90, 100];
      const stateAll = [...stateWait, ...stateReceived];
      const billTradeStateMap = {
        1: stateWait,
        2: stateReceived,
        3: stateAll
      };
      const ret = {
        ...this.formSearch,
      };

      if (ret.tradeState === undefined || ret.tradeState === '' || !ret.tradeState.length) {
        ret.tradeState = billTradeStateMap[this.type];
      }


      if (ret.termNum) {
        ret.termNum = this.formatTermNum(ret.termNum);
      }

      return this.appendReqListData(ret, 'receive_bill');
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 清除
    clearFilter: function () {
      this.$refs.table.clearFilter();
      this.formSearch = JSON.parse(this.resetFormSearch);
      this.formSearch.paymentConfirmTime = '';
      // 然后日期组件重新根据init-value赋值
      this.paymentConfirmTimeKey++;
      setTimeout(() => {
        this.onPageChange({ page: 1 });
      }, 300);
    },
  },
};
</script>

<style lang="scss">
.receive-order-item {
  // display: flex;
  // flex-direction: column;
  // height: 100%;
  .tab {
    margin-left: -16px;
    margin-right: -16px;
  }

  .half-content {
    width: 25%;
    display: inline-block;
  }

  .half-width {
    width: 50% !important;
  }

  .underline {
    color: #0d9ae0;
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
